// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState, useEffect, useRef} from 'react';
import cn from 'classnames';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {can_order_be_cancelled, can_order_be_changed, can_order_be_refunded,
    can_order_be_upgraded, can_order_transfer_bw, get_payment_renew_url,
    ORDER_TYPE_NAMES} from './utils';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {useHistory} from 'react-router';
import Icon_active from '../../img/icons/16/active.svg';
import Icon_check from '../../img/icons/8/check.svg';
import Icon_history from '../../img/icons/16/history.svg';
import Icon_no_active_plans from '../../img/dashboard/no_active_plans.svg';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {Splash_screen_loader} from
    '../../ui/splash_screen_loader/splash_screen_loader';
import {cc_map_small} from './my_account';
import {Modal} from '../../../../hola/pub/lib/modal';
import {perr} from 'hola_pub_util';
import {Btn_loader} from './btn_loader';
import date from '/util/date.js';
import {use_app_context} from '../../lib/app_context';
import {Cancel_dialog, Cancel_success_modal,
    Confirmation_dialog} from './dialogs';
import storage from '/util/storage.js';

import styles from './payment_history.module.less';

const is_order_expired = item=>{
    const expiration_date = new Date(item.subscription_until || item.until);
    const current_date = new Date();
    if (expiration_date > current_date)
        return false;
    return expiration_date < current_date || item.deactivated;
};

interface i_navigation_props {
    current_view: string;
    on_nav: (view: string)=>void;
}

const Navigation_bar = ({current_view, on_nav}: i_navigation_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.navigation_wrap}>
      <span onClick={()=>on_nav('main')}
        className={cn(theme.p12, theme.med, theme.color_n300)}>
        My account
      </span>
      <span className={cn(styles.separator, theme.p12, theme.med,
        theme.color_n300)}>
        {'>'}
      </span>
      <span onClick={()=>on_nav('payment_history')}
        className={cn(theme.p12, theme.med,
          current_view=='payment_history' ? theme.color_n500 :
          theme.color_n300)}>
            Subscriptions and Payments
      </span>
      {current_view.includes('product_') && <>
        <span className={cn(styles.separator, theme.p12, theme.med,
          theme.color_n300)}>
          {'>'}
        </span>
        <span className={cn(theme.p12, theme.med, theme.color_n500)}>
          {ORDER_TYPE_NAMES[current_view.replace('product_', '') as Proxy_type]
            || 'Proxies'}
        </span>
      </>}
    </div>;
};

interface i_payment_info {
    payment: {
        amount: number;
        currency: string;
    };
    card: {
        type: string;
        last4: string;
    };
    last_payment_date: string;
    order: {
        amount: number;
        unit: string;
        client_id: string;
    };
}

interface i_plan_card_props {
    order: any;
    product_type: string;
    payment_info?: i_payment_info;
    is_active: boolean;
    on_nav: (view: string, order?: any)=>void;
}

export const type_to_table_cn: Record<Proxy_type, string> = {
    [Proxy_type.SDC]: styles.table_shared_dc,
    [Proxy_type.DDC]: styles.table_dedicated_dc,
    [Proxy_type.ISP]: styles.table_isp,
    [Proxy_type.ISPPREM]: styles.table_isp_plus,
    [Proxy_type.RES]: styles.table_smart_resi,
    [Proxy_type.EV_RES]: styles.table_smart_resi,
    [Proxy_type.SNK]: styles.table_smart_resi,
    [Proxy_type.SHARED_ISP]: styles.table_dedicated_dc,
    [Proxy_type.EV_ISP]: styles.table_dedicated_dc,
    [Proxy_type.SCR]: styles.table_dedicated_dc,
    [Proxy_type.UNKNOWN]: styles.table_dedicated_dc,
};

const Plan_card = ({order, product_type, payment_info, is_active, on_nav}:
    i_plan_card_props)=>{
    const {theme} = useContext(Settings_context);
    const lookup_type = product_type == 'events_resi_group' ?
        'events_isp' : product_type;
    const title = ORDER_TYPE_NAMES[lookup_type as Proxy_type] || 'Proxies';
    const next_bill_date = new Date(order.subscription_until)
        .toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        });
    const bill_msg_text = payment_info?.payment?.amount !== undefined ?
        `Your next bill is for $${payment_info.payment.amount}` +
        ` on ${next_bill_date}` : null;
    const bill_message = is_active ?
        bill_msg_text || <Btn_loader /> :
        `Expiration date: ${next_bill_date}`;
    return <div
      className={cn(styles.plan_card,
        is_active ?
          type_to_table_cn[lookup_type as Proxy_type] :
          styles.history_card
      )}>
      <div className={styles.card_header}>
        <div className={styles.header_content}>
          <p className={cn(theme.p14, theme.med)}>{title}</p>
          <p className={cn(theme.p12, theme.reg)}>
            Order token: {order.client_id}
          </p>
        </div>
      </div>
      <div className={styles.card_content}>
        <div className={styles.info_group}>
          <p className={cn(theme.p12, theme.reg)}>
            {order.unit == 'gb' ?
              `${order.plan_limit / 1000000000} GB` :
              `${order.ips_amount} IPs`
            }
          </p>
          {is_active &&
            <div className={styles.payment_info}>
              {String(order.subscr_id)?.startsWith('I-') ?
                <div className={styles.card_info}>
                  {cc_map_small.paypal.icon}
                  <span className={cn(theme.p12, theme.reg)}>PayPal</span>
                </div>
              : payment_info?.card ?
                <div className={styles.card_info}>
                  {cc_map_small[payment_info.card.type]?.icon}
                  <span className={cn(theme.p12, theme.reg)}>
                    **** {payment_info.card.last4}
                  </span>
                </div>
              :
                <Btn_loader />
              }
            </div>
          }
          <p className={cn(theme.p12, theme.med)}>
            {bill_message}
          </p>
        </div>
        <Button
          caption={is_active ? 'Manage subscription' :
            'View subscription history'}
          color={'transparent'}
          size={'xs'}
          round={false}
          cls={styles.manage_btn}
          on_click={()=>on_nav(`product_${product_type}`, order)}
        />
      </div>
    </div>;
};

const History_banner = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.history_banner}>
      <p className={cn(theme.p12, theme.reg)}>
        Payment history is available starting from November 2024 onward
      </p>
    </div>;
};

interface i_plan_list_props {
    orders: Record<string, any[]>;
    payment_info_map: Record<string, i_payment_info>;
    is_active: boolean;
    on_nav: (view: string, order?: any)=>void;
}

const Plan_list = ({orders, payment_info_map, is_active, on_nav}:
    i_plan_list_props)=>{
    return <div className={styles.plans_list}>
      {Object.entries(orders).map(([product_type, _orders])=>
        _orders.map(order=>
          <Plan_card
            key={order._id}
            order={order}
            product_type={product_type}
            payment_info={payment_info_map[order.subscr_id]}
            is_active={is_active}
            on_nav={on_nav}
          />
        )
      )}
    </div>;
};

interface i_processed_transaction {
    date: string;
    full_date: string;
    description: string;
    amount: string;
    status: string;
    gateway: string;
}

interface i_payment_history_props {
    on_back: ()=>void;
    user: string;
}

const reduce_nearby_transactions = (transactions: any[])=>{
    return transactions
        .sort((a, b)=>date.get(a.created_at).getTime()
            - date.get(b.created_at).getTime())
        .reduce((acc: any[], curr)=>{
            const last_tx = acc[acc.length - 1];
            const is_within_5sec = last_tx &&
                Math.abs(date.get(curr.created_at).getTime()
                    - date.get(last_tx.created_at).getTime()) <= 5000;
            if (is_within_5sec)
            {
                return curr.amount > last_tx.amount ?
                    [...acc.slice(0, -1), curr] : acc;
            }
            return [...acc, curr];
        }, []);
};

const global_cache: Record<string, any> = {};

const cache = {
    get: (key: string)=>global_cache[key] || null,
    set: (key: string, data: any)=>{ global_cache[key] = data; },
    clear: (key: string)=>{ delete global_cache[key]; }
};

const fetch_data = (subscr_ids, user)=>etask(function*(){
    if (!subscr_ids?.length)
    {
        perr({
            id: 'payment_data_missing_subscr_ids',
            info: {user_id: user}
        });
        return null;
    }
    const cache_key = `payment_data_${user}`;
    const cached_data = cache.get(cache_key);
    if (cached_data)
        return cached_data;
    const ids_param = subscr_ids.join(',');
    const res =
      yield fetch(`/api/get_payment_data?uid=${user}&subscr_ids=${ids_param}`);
    if (!res || res.error)
    {
        console.error('Payment data fetch error:', {
            error: res?.error || 'No response'
        });
        perr({
            id: 'payment_data_fetch_error',
            info: {
                error: res?.error || 'No response',
                user_id: user
            }
        });
        return null;
    }
    cache.set(cache_key, res);
    return res;
});

const No_active_plans = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.no_active_plans}>
      <Icon_no_active_plans/>
      <div className={styles.no_active_plans_text}>
        <p className={cn(theme.p16, theme.med, theme.color_n700)}>
          No active plan? Let's fix that.
        </p>
        <p className={cn(theme.p14, theme.color_n700)}>
          Explore our plans and find the perfect fit
        </p>
      </div>
      <Button caption='Explore plans' fit size='sm' round={false}
        to='/dashboard/page/pricing'/>
    </div>;
};

export const Payment_history =({on_back, user}: i_payment_history_props)=>{
    const {theme} = useContext(Settings_context);
    const _history = useHistory();
    const {params} = use_pathname();
    const {dashboard} = use_app_context();
    const {dispatch, info} = dashboard;
    const [is_loading, set_is_loading] = useState(true);
    const [active_tab, set_active_tab] =
        useState<'active_plans'|'plan_history'>(
        params.section=='history' ? 'plan_history' : 'active_plans');
    const [payment_info_map, set_payment_info_map] =
        useState<Record<string, i_payment_info>>({});
    const [transactions_map, set_transactions_map] =
        useState<Record<string, i_processed_transaction[]>>({});
    const [organized_orders, set_organized_orders] = useState<{
        active: Record<string, any[]>;
        history: Record<string, any[]>;
    }>({active: {}, history: {}});
    const handle_refresh = ()=>{
        if (!user)
            return;
        const cache_key = `payment_data_${user}`;
        cache.clear(cache_key);
        dispatch({type: 'refresh_orders'});
    };
    const get_product_type = (order: any)=>{
        if (!order)
            return '';
        if (order.type == 'events_resi_group')
            return order.type;
        for (const [type, orders] of Object.entries(info.orders))
        {
            if (orders.find(o=>o.client_id == order.client_id))
                return type;
        }
        return '';
    };
    const get_order_by_token = (client_id: string)=>{
        if (!client_id)
            return null;
        if (info?.orders)
        {
            for (const orders of Object.values(info.orders))
            {
                const found_order =
                    orders.find(order=>order.client_id == client_id);
                if (found_order)
                    return found_order;
            }
        }
        if (info?.zone_groups)
        {
            const found_group =
                info.zone_groups.find(group=>group._id == client_id);
            if (found_group)
            {
                return {
                    ...found_group,
                    client_id: found_group._id,
                    plan_limit: found_group.limit,
                    subscription_until: found_group.subscription_until,
                    cancelled_manually: found_group.subscription_cancelled,
                };
            }
        }
        return null;
    };
    const handle_nav = (new_view: string, order?: any)=>{
        if (new_view == 'main')
            return on_back();
        if (new_view == 'payment_history')
        {
            _history.push(`/dashboard/page/account/section/${params.section}`);
            return;
        }
        if (order)
        {
            _history.push(
                `/dashboard/page/account/section/${params.section}/token/${
                  order.client_id}`
            );
        }
    };
    const handle_tab_change = (tab: 'active_plans' | 'plan_history')=>{
        set_active_tab(tab);
        const section = tab=='active_plans' ? 'active' : 'history';
        _history.push(`/dashboard/page/account/section/${section}`);
    };
    const process_transactions = (raw_transactions: any[])=>{
        const processed: Record<string, i_processed_transaction[]> = {};
        reduce_nearby_transactions(raw_transactions
            .filter(t=>
                t.subscr_id && (
                    t.type == 'payment_intent.succeeded' ||
                    t.type == 'PAYMENT.SALE.COMPLETED' ||
                    t.type == 'BILLING.SUBSCRIPTION.RENEWED' ||
                    t.type == 'CHARGE' ||
                    t.type == 'RECURRING'
                )
            ))
            .forEach(t=>{
                if (!processed[t.subscr_id])
                    processed[t.subscr_id] = [];
                processed[t.subscr_id].push({
                    date: new Date(t.created_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit'
                    }),
                    full_date: t.created_at,
                    description: 'Proxy plan',
                    amount: `$${t.amount}`,
                    status: t.refunded ? 'Refunded' : 'Succeeded',
                    gateway: t.gateway,
                });
            });
        return processed;
    };
    useEffect(()=>{
        if (params.token && info?.orders &&
          !(get_order_by_token(params.token)?.subscr_id in payment_info_map))
        {
            handle_refresh();
        }
    }, [params.token]);
    const first_load = useRef(true);
    const request_lock = useRef(false);
    useEffect(()=>{
        if (!user || !info?.orders || request_lock.current)
            return;
        if (first_load.current || params.token)
        {
            request_lock.current = true;
            first_load.current = false;
            etask(function*(){
                try {
                    const subscr_ids = new Set();
                    Object.values(info.orders).forEach(orders=>{
                        orders.forEach(order=>{
                            if (order.subscr_id)
                                subscr_ids.add(order.subscr_id);
                        });
                    });
                    info?.zone_groups?.forEach(group=>{
                        if (group.subscr_id)
                            subscr_ids.add(group.subscr_id);
                    });
                    const res = yield fetch_data(Array.from(subscr_ids), user);
                    if (res?.transactions)
                    {
                        set_transactions_map(
                            process_transactions(res.transactions));
                    }
                    if (res?.payment_info_map)
                        set_payment_info_map(res.payment_info_map);
                    set_is_loading(false);
                } catch(e){
                    console.error('Fetch error:', e);
                    set_is_loading(false);
                } finally {
                    request_lock.current = false;
                }
            });
        }
    }, [user, info?.orders, params.token]);
    useEffect(()=>{
        const active: Record<string, any[]> = {};
        const history: Record<string, any[]> = {};
        const processed_client_ids = new Set();
        if (info?.orders)
        {
            Object.entries(info.orders).forEach(([product_type, orders])=>{
                if (!active[product_type])
                    active[product_type] = [];
                if (!history[product_type])
                    history[product_type] = [];
                orders.forEach(order=>{
                    if (processed_client_ids.has(order.client_id) ||
                        !order.subscr_id || order.free_zone)
                    {
                        return;
                    }
                    processed_client_ids.add(order.client_id);
                    if (!is_order_expired(order))
                        active[product_type].push(order);
                    else
                        history[product_type].push(order);
                });
            });
        }
        if (info?.zone_groups)
        {
            info.zone_groups.forEach(group=>{
                const product_type = group.type;
                if (!active[product_type])
                    active[product_type] = [];
                if (!history[product_type])
                    history[product_type] = [];
                if (!processed_client_ids.has(group._id) && group.subscr_id)
                {
                    const group_order = {
                        ...group,
                        client_id: group._id,
                        unit: group.unit || 'gb',
                        plan_limit: group.limit,
                        subscription_until: group.subscription_until,
                    };
                    if (!is_order_expired(group_order))
                        active[product_type].push(group_order);
                    else
                        history[product_type].push(group_order);
                }
            });
        }
        set_organized_orders({active, history});
    }, [info?.orders, info?.zone_groups]);
    useEffect(()=>{
        if (params.token)
        {
            if (!info?.orders)
            {
                set_is_loading(true);
                dispatch({type: 'refresh_orders'});
                return;
            }
            const order = get_order_by_token(params.token);
            if (!order)
            {
                set_is_loading(false);
                return;
            }
            if (!order.subscr_id)
            {
                perr({
                    id: 'payment_info_order_not_found',
                    info: {
                        token: params.token,
                        user_id: user
                    }
                });
                set_is_loading(false);
                return;
            }
            if (!(order.subscr_id in payment_info_map))
            {
                set_is_loading(true);
                return;
            }
            set_is_loading(false);
        }
    }, [params.token, info?.orders, payment_info_map]);
    const get_current_view = ()=>{
        if (!params.section)
            return 'main';
        if (params.token)
        {
            const order = get_order_by_token(params.token);
            const product_type = get_product_type(order);
            return `product_${product_type}`;
        }
        return 'payment_history';
    };
    let has_order_history = false, has_active_plans = false;
    const {history, active} = organized_orders;
    for (const key in history)
    {
        if (Array.isArray(history[key]) && history[key].length > 0)
        {
            has_order_history = true;
            break;
        }
    }
    for (const key in active)
    {
        if (Array.isArray(active[key]) && active[key].length > 0)
        {
            has_active_plans = true;
            break;
        }
    }
    const current_view = is_loading ? 'payment_history' : get_current_view();
    return <div className={styles.payment_history}>
      {params.token ?
        <>
          {is_loading ?
            <Splash_screen_loader show={true}/>
          :
            <Plan_info
              product_type={get_product_type(get_order_by_token(params.token))}
              on_back={()=>handle_nav('payment_history')}
              order={get_order_by_token(params.token)}
              payment_info={
                payment_info_map[get_order_by_token(params.token)?.subscr_id]
              }
              transactions={
                transactions_map[get_order_by_token(params.token)?.subscr_id]
                || []
              }
              refresh_orders={handle_refresh}
            />
          }
        </>
      :
        <>
          <Navigation_bar
            current_view={current_view}
            on_nav={handle_nav}
          />
          {<div className={cn(styles.plan_tabs,
            !has_order_history && styles.no_border_bottom)}>
            <Button
              caption={<div className={styles.tab_content}>
                <Icon_active/>
                <span>Active subscriptions</span>
              </div>}
              cls={cn(styles.tab,
                active_tab=='active_plans' && styles.active)}
              color='transparent_grey'
              on_click={()=>handle_tab_change('active_plans')}
            />
            {has_order_history && <Button
              caption={<div className={styles.tab_content}>
                <Icon_history/>
                <span>Subscriptions history</span>
              </div>}
              color='transparent_grey'
              cls={cn(styles.tab,
                active_tab=='plan_history' && styles.active)}
              on_click={()=>handle_tab_change('plan_history')}
            />}
          </div>}
          {active_tab == 'active_plans' && !has_active_plans ?
            <No_active_plans/> :
            Object.keys(organized_orders[active_tab=='active_plans' ?
              'active' : 'history']).length ?
              <Plan_list
                orders={organized_orders[active_tab=='active_plans' ?
                  'active' : 'history']}
                payment_info_map={payment_info_map}
                is_active={active_tab=='active_plans'}
                on_nav={handle_nav}
              /> :
              <div className={styles.empty_block}>
                <div className={styles.text_wrapper}>
                  <p className={cn(theme.p18, theme.med, theme.color_n700)}>
                    You currently don't have any payments
                  </p>
                  <p className={cn(theme.p14, theme.reg, theme.color_n600)}>
                    Check out our Proxy package options and choose the right
                    one for you!
                  </p>
                </div>
                <Button caption="Select plan" color="black" size="md"
                  round={false} to="/pricing"/>
              </div>
          }
          {active_tab == 'plan_history' && <History_banner />}
          </>
      }
    </div>;
};

const format_date =
    (_date: string)=>new Date(_date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
});

interface i_resume_modal_content_props {
  on_close: ()=>void;
  on_resume: ()=>void;
}

const Resume_modal_content = ({on_close, on_resume}:
  i_resume_modal_content_props)=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.cancel_modal}>
    <p className={cn(theme.p20, theme.bold)}>
      Resume plan renewal
    </p>
    <p className={cn(theme.p16, theme.med, theme.color_n600)}>
      Are you sure you want to resume the auto-renewal of your plan?
    </p>
    <div className={styles.modal_buttons}>
      <Button
        caption="Resume renewal"
        color="black"
        on_click={()=>{
          on_resume();
        }}
        size="s"
        round={false}
      />
      <Button
        caption="Keep cancel"
        color="transparent"
        on_click={()=>{
          on_close();
        }}
        size="s"
        round={false}
      />
    </div>
  </div>;
};

interface i_plan_info_props {
    product_type: string;
    on_back: ()=>void;
    order: any;
    payment_info: i_payment_info;
    transactions: i_processed_transaction[];
    refresh_orders: ()=>void;
}

const get_change_period_title =
(can_transfer_bw: boolean, can_refund: boolean)=>{
    if (can_refund)
    {
        return can_transfer_bw ? 'By switching to a monthly plan, you can'+
            ' choose to transfer your unused bandwidth to your monthly'+
            ' plan, or get a refund of the days you didn`t use.' :
            'By switching to a monthly plan, you can get a refund of the'+
            ' days you didn\'t use.';
    }
    return can_transfer_bw ?
        'By switching'+
        ' to a monthly plan, you can either transfer your unused bandwidth'+
        ' and start using it right away, or request a refund for the'+
        ' unused days':
        'By switching'+
        ' to a monthly plan, you can request a refund for the unused days';
};

const Plan_info = ({product_type, on_back, order, payment_info, transactions,
    refresh_orders}: i_plan_info_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const [cancel_modal, set_cancel_modal] = useState(false);
    const [resume_modal, set_resume_modal] = useState(false);
    const [change_period_shown, set_change_period_shown] = useState(false);
    const [cancel_shown, set_cancel_shown] = useState(false);
    const [cancel_success_shown, set_cancel_success_shown] = useState(false);
    const [change_plan_shown, set_change_plan_shown] = useState(false);
    const [payment_method_change_shown, set_payment_method_change_shown] =
        useState(false);
    if (!order || !product_type)
      return <Splash_screen_loader show={true}/>;
    const is_expired = is_order_expired(order);
    const lookup_type = product_type == 'events_resi_group' ?
        'events_isp' : product_type;
    const title = ORDER_TYPE_NAMES[lookup_type as Proxy_type] || 'Proxies';
    const transaction_gateway = transactions[transactions.length-1];
    const handle_cancel_click = ()=>set_cancel_modal(true);
    const handle_resume_click = ()=>{
        set_resume_modal(true);
    };
    const handle_payment_update = ()=>{
        set_payment_method_change_shown(true);
    };
    const handle_payment_method_confirm = ()=>{
        const update_url = get_payment_renew_url(order);
        storage.set('renew_update_cc_orig', location.pathname);
        history.push(update_url);
        set_payment_method_change_shown(false);
    };
    const handle_subscription_cancel = ()=>etask(function*(){
        try {
            const res = yield fetch('/users/payment/update_auto_renewal'
              +'?no_redirect=1', {
                method: 'POST',
                json: true,
                body: {zone_id: order._id, auto_renew: false},
            });
            perr({id: 'toolip_cancel_subscription_from_dashboard',
              info: {err: res?.result?.error, ok: res=='ok'}
            });
            set_cancel_modal(false);
            refresh_orders();
          } catch(e){
              console.error('Failed to cancel subscription:', e);
          }
    });
    const handle_subscription_resume =()=>etask(function*(){
        try {
            const res = yield fetch('/users/payment/update_auto_renewal'
              +'?no_redirect=1', {
                method: 'POST',
                json: true,
                body: {zone_id: order._id, auto_renew: true},
            });
            perr({id: 'toolip_update_auto_renewal_from_dashboard',
              info: {err: res?.result?.error, ok: res=='ok'}
            });
        } catch(e){
            console.error(e);
        }
        set_resume_modal(false);
        refresh_orders();
    });
    const show_upgrade = can_order_be_upgraded(order);
    const can_refund = can_order_be_refunded(order);
    const can_transfer_bw = can_order_transfer_bw(order);
    const change_period_title = get_change_period_title(
        can_transfer_bw, can_refund);
    const note = can_refund ? '*A refund will be issued after switching to'+
        ' the monthly plan' : null;
    const change_subtitle = 'By switching to a different plan, you can get a '+
        'refund for the days you didn`t use.';
    const meathod_change_note = `If you're switching between credit card and`+
        ` PayPal, a temporary charge will be applied and then automatically`+
        ` refunded.`;
    return <div className={styles.plan_info}>
      <Navigation_bar
        current_view={`product_${product_type}`}
        on_nav={on_back}
      />
      <div className={styles.info_wrapper}>
        <div className={cn(styles.info_card,
          type_to_table_cn[lookup_type as Proxy_type])}>
          <div className={styles.card_header}>
            <p className={cn(theme.p16, theme.med)}>{title}</p>
          </div>
          <div className={styles.card_content}>
            <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Order token
              </p>
              <p className={cn(theme.p14, theme.med, styles.value)}>
                {order?.client_id}
              </p>
            </div>
            <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Last payment date
              </p>
              <p className={cn(theme.p14, theme.med, styles.value)}>
                {payment_info?.last_payment_date ?
                  format_date(payment_info.last_payment_date) : '--'}
              </p>
            </div>
            {!is_expired && <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Next renewal date
              </p>
              <div className={styles.value_group}>
                <p className={cn(theme.p14, theme.med, styles.value)}>
                  {order?.subscription_until ?
                    format_date(order.subscription_until) : '--'}
                </p>
                {show_upgrade &&
                  <a className={cn(theme.P, theme.p14, theme.med, styles.link)}
                    onClick={()=>set_change_period_shown(true)}>
                    Change to monthly
                  </a>
                }
              </div>
            </div>}
            <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Order Amount
              </p>
              <p className={cn(theme.p14, theme.med, styles.value)}>
                {order?.unit == 'gb' ?
                  `${order.plan_limit / 1000000000} GB` :
                  `${order.ips_amount} proxies`}
              </p>
            </div>
            {!is_expired && <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Payment type
              </p>
              <div className={styles.value_group}>
                <p className={cn(theme.p14, theme.med)}>
                  {is_expired || order.subscription_cancelled ||
                    order.cancelled_manually ?
                    'Auto-renewal disabled' : 'Renewal'
                  }
                </p>
                {!is_expired && !order.cancelled_manually &&
                  !order.subscription_cancelled ?
                  <a className={cn(theme.P, theme.p14, theme.med, styles.link)}
                    onClick={handle_cancel_click}>
                    Cancel auto-renewal
                  </a>
                  : !is_expired ?
                  <a className={cn(theme.P, theme.p14, theme.med,
                    styles.link)} onClick={handle_resume_click}>
                      Resume auto-renewal
                  </a> : null
                }
              </div>
            </div>}
            <div className={styles.field}>
              <p className={cn(theme.p12, theme.reg, styles.label)}>
                Payment method
              </p>
              <div className={styles.value_group}>
                {String(order.subscr_id)?.startsWith('I-') ?
                  <div className={styles.card_info}>
                    {cc_map_small.paypal.icon}
                    <p className={cn(theme.p14, theme.med)}>
                      {cc_map_small.paypal.title}
                    </p>
                  </div>
                : payment_info?.card ?
                  <div className={styles.card_info}>
                    {cc_map_small[payment_info.card.type]?.icon}
                    <p className={cn(theme.p14, theme.med)}>
                      **** {payment_info.card.last4}
                    </p>
                  </div>
                :
                  <Btn_loader />
                }
                {!is_expired && <a className={cn(theme.P, theme.p14, theme.med,
                  styles.link)} onClick={handle_payment_update}>
                  Change payment method
                </a>}
              </div>
            </div>
            {!order.disabled && !order.is_expired &&
              <div className={styles.btn_container}>
                {can_order_be_cancelled(order) &&
                  <Button caption='Cancel & refund' color='transparent'
                    on_click={()=>set_cancel_shown(true)} round={false}
                    cls={styles.btn} size='xs'/>}
                {can_order_be_changed(order) &&
                  <Button caption='Change plan' size='xs'
                    on_click={()=>set_change_plan_shown(true)}
                    color='black' round={false} cls={styles.btn}/>}
              </div>}
              <Cancel_dialog
                is_open={cancel_shown}
                width={500}
                close={()=>set_cancel_shown(false)}
                gateway={transaction_gateway.gateway}
                product_id={order._id}
                can_change_plan={can_order_be_changed(order)}
                on_confirm={()=>{
                  set_cancel_shown(false);
                }}
                on_change_plan={()=>{
                  set_cancel_shown(false);
                }}
                on_cancel_success={()=>{
                  set_cancel_shown(false);
                  set_cancel_success_shown(true);
                }}
              />
              <Cancel_success_modal
                is_open={cancel_success_shown}
                on_close={()=>{
                  set_cancel_success_shown(false);
                  refresh_orders();
                }}
                on_buy_plan={()=>{
                  set_cancel_success_shown(false);
                  history.push('/pricing');
                }}
              />
          </div>
        </div>
      </div>
      {transactions.length > 0 && <History_table transactions={transactions}
        subscr_id={order.subscr_id} zone_id={order.client_id} />}
      <Modal is_open={cancel_modal}
        cls={styles.modal_wrapper}
        on_close={()=>set_cancel_modal(false)}
        content_when_open
        width={460}>
        <div className={styles.cancel_modal}>
          <p className={cn(theme.p20, theme.bold)}>Cancel plan renewal</p>
          <p className={cn(theme.p16, theme.med, theme.color_n600)}>
            Are you sure you want to cancel the auto-renewal of your plan?
          </p>
          <div className={styles.modal_buttons}>
            <Button caption="Cancel renewal" color="black" round={false}
              size="s" on_click={handle_subscription_cancel}/>
            <Button caption="Keep renewal" color="transparent" round={false}
              size="s" on_click={()=>set_cancel_modal(false)}/>
          </div>
        </div>
      </Modal>
      <Modal
        is_open={resume_modal}
        cls={styles.modal_wrapper}
        on_close={()=>set_resume_modal(false)}
        content_when_open
        width={460}>
        <Resume_modal_content
          on_close={()=>set_resume_modal(false)}
          on_resume={handle_subscription_resume}
        />
      </Modal>
      <Confirmation_dialog
        is_open={change_period_shown}
        caption_cancel={can_refund ? 'Get a Refund' : 'Request for Refund'}
        caption_confirm='Transfer bandwidth'
        title='Changing plan period'
        note={note}
        sub_title={change_period_title}
        width={476}
        close={()=>set_change_period_shown(false)}
        hide_buttons={can_transfer_bw ? [] : ['confirm']}
        on_cancel={()=>{
          if (can_refund)
          {
            const plan_id = order.plan_id.replace('1w', '1m');
            history.push(`/pricing/checkout?plan_id=${plan_id}` +
              `&migrate_product_id=${order._id}&with_refund=1`);
            return;
          }
          set_change_period_shown(false);
          history.push('/dashboard/page/plans?support_form=1');
        }}
        on_confirm={()=>{
          const plan_id = order.plan_id.replace('1w', '1m');
          history.push(`/pricing/checkout?plan_id=${plan_id}` +
            `&migrate_product_id=${order._id}`);
        }}
      />
      <Confirmation_dialog
        is_open={change_plan_shown}
        caption_confirm='Cancel'
        caption_cancel='Choose new plan'
        title='Changing plan'
        sub_title={change_subtitle}
        note='* A refund will be issued after switching to a new plan'
        width={480}
        close={()=>set_change_plan_shown(false)}
        hide_buttons={['confirm']}
        on_cancel={()=>{
          set_change_plan_shown(false);
          history.push(`/pricing?refund_product_id=${order._id}`);
        }}
      />
      <Confirmation_dialog
        is_open={payment_method_change_shown}
        caption_confirm='Update Payment Method'
        caption_cancel='Dismiss'
        title='Update payment method'
        sub_title={meathod_change_note}
        width={480}
        close={()=>set_payment_method_change_shown(false)}
        on_confirm={handle_payment_method_confirm}
        on_cancel={()=>set_payment_method_change_shown(false)}
      />
    </div>;
};

interface i_history_table_props {
    transactions: i_processed_transaction[];
    subscr_id: string;
    zone_id: string;
}

const History_table = ({transactions, subscr_id, zone_id}:
i_history_table_props)=>{
    const {theme} = useContext(Settings_context);
    const {user} = use_app_context();
    const [stripe_receipts, set_stripe_receipts] = useState(null);
    const sorted_transactions = [...transactions].sort((a, b)=>
        date.get(b.full_date) - date.get(a.full_date)
    );
    const show_receipt = transactions.some(t=>t.gateway == 'stripe');
    const get_stripe_receipts = ()=>etask(function*(){
        if (!show_receipt)
            return;
        try {
            const res = yield fetch('/api/get_stripe_receipts?' +
                `hola_uid=${user.hola_uid}&subscr_id=${subscr_id}&` +
                `zone_id=${zone_id}`);
            if (res.receipt_urls)
                return res.receipt_urls;
            return null;
        } catch(e){ console.error('failed to fetch:', e); }
    });
    useEffect(()=>{
        if (!subscr_id || !zone_id || !user)
            return;
        Promise.resolve(get_stripe_receipts())
            .then(res=>set_stripe_receipts(res))
            .catch(err=>console.error('Error fetching stripe receipts:', err));
    }, [subscr_id, zone_id, user]);
    return <div className={styles.history_section}>
      <p className={cn(theme.p16, theme.med)}>Payment History</p>
      <div className={styles.history_table}>
        <div className={styles.table_header}>
          <p className={cn(theme.p12, theme.med)}>Date issued</p>
          <p className={cn(theme.p12, theme.med)}>Description</p>
          <p className={cn(theme.p12, theme.med)}>Amount</p>
          <p className={cn(theme.p12, theme.med)}>Status</p>
          {show_receipt && <p className={cn(theme.p12, theme.med)}>Receipt</p>}
        </div>
        {sorted_transactions.map((t, idx)=>
          <div key={idx} className={styles.table_row}>
            <p className={cn(theme.p12, theme.reg)}>{t.date}</p>
            <p className={cn(theme.p12, theme.reg)}>
              {t.description}
            </p>
            <p className={cn(theme.p12, theme.reg)}>{t.amount}</p>
            <div className={styles.status_cell}>
              {t.status == 'Succeeded' ?
                <div className={styles.status_paid}>
                  <Icon_check />
                  <p className={cn(theme.p12, theme.reg)}>Paid</p>
                </div> :
                <p className={cn(theme.p12, theme.reg)}>Refund</p>
              }
            </div>
            {t.gateway == 'stripe' && stripe_receipts?.[idx] &&
              <a className={cn(theme.P, theme.p12, theme.color_n600)}
                href={`${stripe_receipts?.[idx]}`}
                target="_blank" rel="noreferrer noopener">
                View
              </a>}
          </div>
        )}
      </div>
    </div>;
};
